import React, { ReactNode } from 'react';

import { Button } from '../styles';

interface ButtonProps {
  onClick(): any;
  style?: any;
  children?: ReactNode;
  disabled?: boolean;
  title?: string;
  id?: string;
}

export const ConfirmButton: React.FC<ButtonProps> = ({
  onClick,
  style,
  children,
  disabled = false,
  title = '',
  id = '',
}) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      id={id}
      style={style}
      className="confirm"
      disabled={disabled}
      title={title}
    >
      {children || 'Confirmar'}
    </Button>
  );
};

export default ConfirmButton;
